// Minimal SSE (Server-Sent Events) parser used by every streaming client in
// the app. Returns a generator that yields {event, data} frames from a text
// chunk stream (typically produced by `resp.body.getReader()`).
//
// Usage:
//   const parse = makeSseParser();
//   for (const frame of parse(chunkText)) { ... }
//
// Malformed frames (non-JSON data) are silently ignored.
export function makeSseParser() {
  let buffer = "";
  return function* feed(chunk) {
    buffer += chunk;
    let idx;
    while ((idx = buffer.indexOf("\n\n")) !== -1) {
      const frame = buffer.slice(0, idx);
      buffer = buffer.slice(idx + 2);
      let ev = "message";
      const dataLines = [];
      for (const line of frame.split("\n")) {
        if (line.startsWith("event:")) ev = line.slice(6).trim();
        else if (line.startsWith("data:")) dataLines.push(line.slice(5).trim());
      }
      if (dataLines.length) {
        try {
          yield { event: ev, data: JSON.parse(dataLines.join("\n")) };
        } catch {
          // Malformed data payload in an SSE frame — the server should never
          // emit these, but if it does, drop the frame and keep parsing the
          // stream rather than aborting the whole reader.
          if (typeof console !== "undefined" && console.debug) {
            console.debug("[sse] skipped malformed frame");
          }
        }
      }
    }
  };
}
